// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2016 Minted Inc.
 * All Rights Reserved
 * CTAG:COMMUNITY:CHALLENGES
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, Backbone, $, moment, _) {
  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};

  M.Community.View.FeedbackGallery = Backbone.View.extend({
    model: M.Community.Model.FeedbackGallery,
    template: M.Template.Community.FeedbackGallery,
    designerInfoTemplate: M.Template.Community.UserInfo.FeedbackWidgetDesignerInfo,
    className: 'feedbackGallery',
    events: {
      'click .secondaryActionButton': 'fetchDataAndRender',
    },

    initialize: function() {
      // Do some asserts here
      _.bindAll(this, '_setCurrentModelAndRender', '_renderErrorMessage',
          'fetchDataAndRender');
    },

    /**
     * The main function for initializing the state and rendering this panel.
     * First, it fetches additional data if there isn't any.
     * Then it updates the current state of the dialog, and then renders.
     */
    fetchDataAndRender: function() {
      var that = this;
      if (this.collection.length == 0) {
        this.collection.fetch({
          data: {
            challenge_id: that.options.challengeId
          },
          success: function() {
            that._setCurrentModelAndRender();
          },
          error: function() {
            that._renderErrorMessage();
          }
        });
      } else {
        this._setCurrentModelAndRender();
      }
    },

    /**
     * Helper method. It gets the next item to show, sets it as
     * the current one, and then renders the model if it exists, or renders
     * a short message otherwise.
     */
    _setCurrentModelAndRender: function() {
      this.currentModel = this.collection.shift();

      if (this.currentModel) {
        this.render();
      } else {
        this._renderAllDesignsAnsweredMessage();
      }
    },

    _construct_recent_comments: function () {
      var recentComments = new M.Community.View.Comment({
        designId: this.currentModel.get('designId'),
        count: this.options.recentCommentsLimit,
        commentsUrlPath: this.options.commentsUrlPath
      });

      return recentComments;
    },

    render: function() {
      var templateVars = {
        headerText: 'Give feedback',
        buttonLabel: 'Go to next'
      };
      _.extend(templateVars, this.currentModel.toJSON());
      this.$el.html(this.template(templateVars));

      this.$el.find('.activityCalloutContainer .designerInfoContainer').html(
          this.designerInfoTemplate(this.currentModel.get('designerInfo')));

      // Render the comment box
      var communityComment = this._createCommunityComment(
          this.currentModel.get('designId'));

      this.renderMostRecentComments();
      this.$el.find('.communityCommentContainer').html(communityComment.render().$el);
      this.$el.find('.commentsContainer').html(this.recentComments.$el);

      return this;
    },

    _renderErrorMessage: function() {
      this.$el.html('<p class="text--light">Something went wrong while loading designs. ' +
          'Please try again later.</p>');
    },

    _renderAllDesignsAnsweredMessage: function() {
      //TODO: Find a better message
      this.$el.html('<p class="text--light">Thank you for providing feedback. We\'re ' +
          'currently out of designs.</p>');
    },

    _createCommunityComment: function(designId) {
      var commentOptions = {
        designId: designId,
        urlPaths: {
          communityCommentModelUrlRoot: "/community-comment"
        }
      };
      return new M.Community.View.CommunityComment(commentOptions);
    },

    renderMostRecentComments: function() {
      this.recentComments = this._construct_recent_comments();
      this.recentComments.fetchCommentDataAndRender();
    }
  });

  return {  };

});